import axios from 'axios'
import React, { Component } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import Cookies from 'universal-cookie'
import Contenido from '../components/contenido/Contenido'
import FooterDashboard from '../components/footer/FooterDashboard'
import NavbarGeneral from '../components/navbar/NavbarGeneral'
import Sidebar from '../components/sidebar/SidebarVicerrectoradoAcad'
import ListCoordinaciones from '../components/vicerrectoradoacad/matriculas/ListCoordinaciones'
import Malla from '../components/vicerrectoradoacad/asignaturas/AsignaturasEstCarrCicloVicerrAcad'
import VerPerfil from '../components/vicerrectoradoacad/perfil/VerPerfil'
import GestionPlanes from '../components/vicerrectoradoacad/planes/GestionPlanes'
import GestionEjesPlan from '../components/vicerrectoradoacad/planes/GestionEjesPlan'
import GestionEjes from '../components/vicerrectoradoacad/planes/GestionEjes'
import GestionObjIndicador from '../components/vicerrectoradoacad/planes/GestionObjIndicador'
import GestionProyectos from '../components/vicerrectoradoacad/planes/GestionProyectos'
import CantidadMatri from '../components/vicerrectoradoacad/matriculas/CantidadMatriculados'
import GestionEvalDocentes from '../components/vicerrectoradoacad/evaluacion_docente/GestionEvalDocentes'
import GestionPreguntasEval from '../components/vicerrectoradoacad/evaluacion_docente/GestionPreguntasEval'
import HeteroEvalAsignaturasDocentePeriodo from '../components/vicerrectoradoacad/evaluacion_docente/HeteroEvalAsignaturasDocentePeriodo'
import GestionCreditosExtra from '../components/vicerrectoradoacad/creditos_extra/GestionCreditosExtra'
import GestionEstudianteCreditos from '../components/vicerrectoradoacad/creditos_extra/GestionEstudianteCreditos'
import GestionDocenteCreditos from '../components/vicerrectoradoacad/creditos_extra/GestionDocenteCreditos'
import { ApiUrl } from '../components/services/ApiRest';

const cookie = new Cookies();
const urlAdministrativo=ApiUrl +"admins/"; //pasar id del usuario
const idAdministrativo = cookie.get("idAdministrativo");    //declaramos una variable para usar la cookie del login

const config = {
    headers: { Authorization: `Bearer ${cookie.get("rol")}` }
};

export default class RutasVicerrectoradoAdm extends Component {
    componentDidMount() {
      
        axios.get(urlAdministrativo+idAdministrativo+"?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
          .then(res => {
            const estudiante = res.data;
            this.setState({ estudiante });
            cookie.set('nombres',estudiante.nombres_administrativo,{path:"/"})
            cookie.set('apellidos',estudiante.apellidos_administrativo,{path:"/"})
          })
    }    

    render() {
        if(!cookie.get("log")){
            return(<Redirect to="/login" />);
        }

        if(cookie.get("rol") !== "administrativo"){
        }

        return (
            
            <>
                <NavbarGeneral /> 
                <div id="layoutSidenav" >
                    <Sidebar />
                    <div id="layoutSidenav_content">
                        <main>
                        
                            <div className="container-fluid">                       
                                 {this.props.location.pathname === "/vicerrectoradoacad" && <Contenido />} 
                                    <Route path="/vicerrectoradoacad/listcoordinaciones"  component={ListCoordinaciones} /> 
                                    <Route path="/vicerrectoradoacad/AsignaturasEstCarreraCicloAcad"  component={Malla} />
                                    <Route path="/vicerrectoradoacad/VerPerfilVicerrAcad" component={VerPerfil} /> 
                                    <Route path="/vicerrectoradoacad/GestionPlanes" component={GestionPlanes} /> 
                                    <Route path="/vicerrectoradoacad/GestionEjesPlan" component={GestionEjesPlan} /> 
                                    <Route path="/vicerrectoradoacad/GestionEjes" component={GestionEjes} /> 
                                    <Route path="/vicerrectoradoacad/GestionObjIndicador" component={GestionObjIndicador} /> 
                                    <Route path="/vicerrectoradoacad/GestionProyectos" component={GestionProyectos} /> 
                                    <Route path="/vicerrectoradoacad/cantidadmatri" component={CantidadMatri} /> 
                                    <Route path="/vicerrectoradoacad/GestionEvalDocentes" component={GestionEvalDocentes} /> 
                                    <Route path="/vicerrectoradoacad/GestionPreguntasEval" component={GestionPreguntasEval} /> 
                                    <Route path="/vicerrectoradoacad/HeteroEvalAsignaturasDocentePeriodo" component={HeteroEvalAsignaturasDocentePeriodo} /> 
                                    <Route path="/vicerrectoradoacad/GestionCreditosExtra" component={GestionCreditosExtra} /> 
                                    <Route path="/vicerrectoradoacad/GestionEstudianteCreditos" component={GestionEstudianteCreditos} /> 
                                    <Route path="/vicerrectoradoacad/GestionDocenteCreditos" component={GestionDocenteCreditos} /> 
                             </div>
                        </main>
                        <FooterDashboard />                        
                    </div>                 
                </div>            
            </>
        )
    }
}
